<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">
                  Nuestro propósito
                  <span></span>
                </h1>
                <p class="lead  text-white">
                  Desarrollar y proporcionar herramientas tecnológicas de fácil manejo y en continua evolución para mejorar la rentabilidad, actividad, procesos y la gestión diaria de las notarías.
                </p>
               
              </div>
              <div class="col-lg-6">
                <img v-lazy="'img/nosotros.jpg'" class="w100 img-shadow"/>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <div  class="parallax-container mt--150">
      <parallax fixed >
        
        <img :src="'img/business.jpg'"/>
      </parallax>
    </div>

    <section class="section section-lg bg-white mt--200">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-12 text-center">
            <h2 class="display-3 pb-3">
              Nuestros Valores
              
            </h2>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg ">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-12 text-center">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0 cards-nosotros" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-check-bold"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">Fiabilidad</h6>
                  <p class="description mt-3">
                    <strong>Primer y único fabricante actual de tecnología ágil especializado en el sector notarial.</strong>
                  </p>
                  
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0 cards-nosotros" hover shadow body-classes="py-5">
                  <icon
                    name="fa fa-chart-line"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">Evolución continua</h6>
                  <p class="description mt-3">
                    <strong>Más de 30 años abriendo nuevos caminos y adaptando la tecnología a los diferentes cambios del sector notarial.   (constantes demandas).</strong>
                  </p>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0 cards-nosotros" hover shadow body-classes="py-5">
                  <icon name="fa fa-users" type="danger" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Cocreación</h6>
                  <p class="description mt-3">
                    <strong>Incorporamos a notarios en el desarrollo y mejoras de los productos, para tener en cuenta sus procesos de trabajo. Es NOTIN quien se adapta a la Notaría, no la Notaría a NOTIN.</strong>
                  </p>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0 cards-nosotros" hover shadow body-classes="py-5">
                  <icon name="fa fa-microchip" type="dark" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Aliado tecnológico Integral</h6>
                  <p class="description mt-3">
                    <strong>Proporcionamos a la notaría todo lo necesario para que su gestión sea más ágil, fácil, segura, en definitiva más productiva. Aplicaciones, programas, equipos, sistemas de impresión, domótica,…., y todo lo que necesite.</strong>
                  </p>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0 cards-nosotros" hover shadow body-classes="py-5">
                  <icon name="ni ni-planet" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Comunidad NOTIN</h6>
                  <p class="description mt-3">
                    <strong>Notarios y oficiales colaboradores nos ayudan a desarrollar nuevos productos nuevas mejoras que aplicamos a toda la comunidad de notarias NOTIN. </strong>
                  </p>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0 cards-nosotros" hover shadow body-classes="py-5">
                  <icon name="fa fa-info" type="info" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Formación Contínua</h6>
                  <p class="description mt-3">
                    <strong>Consideramos que el aprendizaje rápido, constante y efectivo de los usuarios es clave para un aprovechamiento total de nuestras herramientas.</strong>
                  </p>
                </card>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg bg-white ">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-12 text-center">
            <h2 class="display-3 pb-3">
              Nuestra Historia
              
            </h2>
            <img v-lazy="'img/timeline.png'" class="w100"/>
          
          </div>
        </div>
      </div>
    </section>

            <SliderTestimonios/>
          
    <div class="profile-page">
      <section class="section section-skew">
        <div class="container">
          <card shadow class="card-profile mt-100" no-body>
            <div class="px-4">
              <div class="row justify-content-center">
                <div class="col-lg-3 order-lg-2">
                  <div class="card-profile-image">
                    <a href="#">
                      <img
                        v-lazy="'img/brand/squareN.png'"
                        class="rounded-circle rounded-notin"
                      />
                    </a>
                  </div>
                </div>
                <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                  <!-- <div class="card-profile-actions py-4 mt-lg-0">
                    <base-button type="info" size="sm" class="mr-4"
                      >Connect</base-button
                    >
                    <base-button type="default" size="sm" class="float-right"
                      >Message</base-button
                    >
                  </div> -->
                </div>
                <div class="col-lg-4 order-lg-1">
                  <div class="card-profile-stats d-flex justify-content-center">
                    <!-- <div>
                      <span class="heading">22</span>
                      <span class="description">Friends</span>
                    </div>
                    <div>
                      <span class="heading">10</span>
                      <span class="description">Photos</span>
                    </div>
                    <div>
                      <span class="heading">89</span>
                      <span class="description">Comments</span>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="row">
                  <div class="col-lg-12 text-center mt-5"><br><br><br>
                      <h1>
                        Nuestros valores: Decálogo Notin                      
                      </h1>
                      <!-- <div class="h6 font-weight-300">
                          <i class="ni location_pin mr-2"></i>Bucharest, Romania
                      </div>
                      <div class="h6 mt-4">
                          <i class="ni business_briefcase-24 mr-2"></i>Solution Manager -
                          Creative Tim Officer
                      </div>
                      <div>
                          <i class="ni education_hat mr-2"></i>University of Computer
                          Science
                      </div> -->
                  </div>
              </div>
              <div class="mt-5 py-5 border-top text-justify">
                <div class="row justify-content-center">
                  <div class="col-lg-12 texto-principios">
                    <card shadow>
                    <p>Aprovechar cualquier trabajo realizado por los usuarios</p>
                    <ul class="star-list">
                    <li>Un dato se introduce una sola vez y el sistema lo recuperar&aacute; all&iacute; donde lo necesite. Conseguimos reducir el coste de elaboraci&oacute;n al repetir datos en distintos departamentos, pero sobre todo evitamos errores de transcripci&oacute;n.</li>
                    </ul>
                    </card>
                    <card shadow>
                    <p>Motivar al equipo de la notar&iacute;a con un &uacute;nico objetivo</p>
                    <ul class="star-list">
                    <li>La filosof&iacute;a del producto crea un conducto &uacute;nico donde los usuarios aportan su informaci&oacute;n y disponen de la introducida por sus compa&ntilde;eros. Es un proceso con una finalidad clara, tutelado por el sistema y con seguimiento para que todos los implicados realicen su labor.</li>
                    </ul>
                    </card>
                    <card shadow>
                    <p>Adaptarnos al estilo de trabajo de su Notar&iacute;a</p>
                    <ul class="star-list">
                    <li>Ning&uacute;n usuario quedar&aacute; fuera del proyecto aunque su forma de trabajar sea diferente a la propuesta. Nuestro sistema h&iacute;brido permite trabajar en cualquier direcci&oacute;n, desarrollando documentos desde modelos o extrayendo informaci&oacute;n de documentos redactados manualmente.</li>
                    </ul>
                    </card>
                    <card shadow>
                    <p>Integrar NOTIN con el ecosistema del despacho</p>
                    <ul class="star-list">
                    <li>Microsoft Outlook, SIGNO, OVC, Acrobat Reader, OCR, &hellip;, son herramientas y plataformas imprescindibles para el trabajo diario en el despacho. Las hemos conectado directamente con NOTIN creando una pasarela que evita la p&eacute;rdida tiempo y fiabilidad en la vinculaci&oacute;n de documentos.</li>
                    </ul>
                    </card>
                    <card shadow>
                    <p>Ayudar y avisar constantemente al usuario para evitar errores</p>
                    <ul class="star-list">
                    <li>Procesos silenciosos constatan la informaci&oacute;n introducida en m&aacute;quinas virtuales para advertir sobre la calidad de la informaci&oacute;n. El an&aacute;lisis se realiza a varios niveles, incluyendo la simulaci&oacute;n del &iacute;ndice para verificar previamente en origen que los datos a exportar tras la firma son id&oacute;neos .</li>
                    </ul>
                    </card>
                    <card shadow>
                    <p>Anticiparnos y ser siempre compatibles con las normativas notariales</p>
                    <ul class="star-list">
                    <li>NOTIN se encuentra adaptado a las normas y legislaci&oacute;n vigente, la estructura interna de nuestros datos es similar a la definida para el &Iacute;ndice Notarial y se adapta &ldquo;en silencio&rdquo; a cualquier posible modificaci&oacute;n futura gracias a su arquitectura abierta.</li>
                    </ul>
                    </card>
                    <card shadow>
                    <p>Atender siempre que se nos necesite y proponer una formaci&oacute;n continua de nuestros usuarios.</p>
                    <ul class="star-list">
                    <li>NEMO, Nuestra pasarela de asistencia ONLINE nos une durante doce horas al d&iacute;a con cada cliente que desee informaci&oacute;n o una conexi&oacute;n inmediata. Adem&aacute;s, en &ldquo;Notin ACADEMY&rdquo; &nbsp;realizamos talleres semanales y proponemos cursos <em>ad hoc</em> para que los usuarios consigan la m&aacute;xima destreza y conocimiento de la herramienta.</li>
                    </ul>
                    </card>
                    <card shadow>
                    <p>Certificar la seguridad y el funcionamiento continuo de nuestros despachos</p>
                    <ul class="star-list">
                    <li>Conscientes de la mala imagen y las consecuencias econ&oacute;micas que puede provocar la p&eacute;rdida de informaci&oacute;n o una ca&iacute;da de servicio inform&aacute;tico en la notar&iacute;a, garantizamos por contrato con el sistema de duplicaci&oacute;n de elementos cr&iacute;ticos ADRA la soluci&oacute;n en minutos de cualquier incidencia t&eacute;cnica que pueda ocurrir.</li>
                    </ul>
                    </card>
                    <card shadow>
                    <p>Investigar, innovar y apostar para que nuestra herramienta CREZCA</p>
                    <ul class="star-list">
                    <li>Cada d&iacute;a aparecen nuevos, interesantes y maravillosos proyectos aplicables al sector notarial de la mano de los sistemas de digitalizaci&oacute;n y de la IA. No existe l&iacute;mite sobre el alcance que las recientes tecnolog&iacute;as van a aportar al mundo de derecho. Nuestro compromiso es llegar hasta donde podamos y siempre un poco m&aacute;s all&aacute;.</li>
                    </ul>
                    </card>
                    <card shadow>
                    <p>Contribuir a la mejora del servicio que presta a sus clientes y aumentar la productividad de la notar&iacute;a</p>
                    <ul class="star-list">
                    <li>Proponemos una reducci&oacute;n importante en procesos administrativos colaterales que actualmente ocupan irremediablemente el tiempo de los oficiales, al reducir dr&aacute;sticamente el tiempo de su procesamiento y permitir la redistribuci&oacute;n inteligente de tareas entre compa&ntilde;eros, liberando as&iacute; a nuestros primeros espadas para que dispongan de tiempo suficiente para &nbsp;tratar profesionalmente a clientes y realizar el resto de labores comerciales que contribuir&aacute; a generar negocio a la Notar&iacute;a.</li>
                    
                    </ul>
                    </card>
                    <!-- <a href="#">Show more</a> -->
                  </div>
                </div>
              </div>
            </div>
          </card>
          <div class="row justify-content-center">
            <div class="col-lg-12 mt-5">
                <card class=" bg-gradient-success border-0" shadow body-classes="py-5">
 
                <h5 class=" text-center">
                  Todas las mejoras aplicadas a nuestro producto y su adecuado manejo del personal tiene como principal objetivo la MEJORA DEL SERVICIO GLOBAL ofrecido por la notaría a sus clientes a trav&eacute;s de la optimizaci&oacute;n del trabajo interno y estableciendo con ellos un nuevo CANAL DE COMUNICACI&Oacute;N DIGITAL que sit&uacute;en a nuestro despacho en un nivel tecnol&oacute;gico acorde al siglo en el que vivimos.
                </h5>
                </card>
            </div>
          </div>
        </div>
      </section>
    </div>
   
    <section class="section section-shaped my-0 overflow-hidden bg-gris">
      <div class="shape shape-style-3 bg-gradient-hash shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container  pb-200">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Blog y Noticias</h2>
          <div class="btn btn-secondary" onclick="window.open('https://notin.es/portal','_blank'))">
            <p class="lead text-white text-center">
              <a class="text-black text-bold"  href="https://notin.es/portal" target="_blank">Lea artículos y noticias del ámbito notarial en nuestro blog</a>
            </p>
          </div>
          <div class="logo-btn">
            <p>
                <a href="https://notin.es/portal">
                <img
                    v-lazy="'img/notin.es.png'"
                    class="w100" style="max-width:546px"/>
                </a>
            </p>
          </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Nosotros",
  components:{
    SliderTestimonios: () => import('../components/SliderTestimonios.vue'),
    Parallax: () => import('vue-parallaxy'),
  },
  data() {
    return {
      slide: 0,
      sliding: null
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  }

};
</script>
<style scoped>

</style>